import React from 'react';

const SvgTrophy = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.1941 2.51099H6.17513C5.63317 2.51099 5.20124 2.96408 5.25064 3.50379C5.66595 8.04109 7.40095 15.511 11.7714 15.511C16.1461 15.511 17.7721 8.02663 18.1197 3.49062C18.1607 2.9556 17.7307 2.51099 17.1941 2.51099Z" stroke="white" strokeWidth="1.41702" strokeLinecap="round" />
      <path d="M18.1385 4.51074H20.2041C20.7369 4.51074 21.1653 4.95121 21.0946 5.47932C20.6716 8.63798 18.6907 13.5107 15.1775 13.5107" stroke="white" strokeWidth="1.41702" strokeLinecap="round" />
      <path d="M5.21669 4.51074H3.15115C2.61833 4.51074 2.18993 4.95121 2.26065 5.47932C2.68364 8.63798 4.66448 13.5107 8.17773 13.5107" stroke="white" strokeWidth="1.41702" strokeLinecap="round" />
      <path d="M7.17773 19.7452V20.5663C7.17773 21.088 7.60068 21.511 8.12241 21.511H15.2331C15.7548 21.511 16.1777 21.0883 16.1777 20.5665V19.7452C16.1777 18.773 15.3618 18.5173 14.9539 18.511H8.40158C7.55807 18.511 7.23422 19.3338 7.17773 19.7452Z" stroke="white" strokeWidth="1.41702" strokeLinecap="round" />
      <path d="M10.1772 18.511V15.511" stroke="white" strokeWidth="1.41702" strokeLinecap="round" />
      <path d="M13.1775 18.511V15.511" stroke="white" strokeWidth="1.41702" strokeLinecap="round" />
      <path d="M6.17749 21.5107H17.1775" stroke="white" strokeWidth="1.41702" strokeLinecap="round" />
    </svg>
  );
};

export default SvgTrophy;
